// extracted by css-extract-rspack-plugin
export default {"popover":"popover-2cRJ-","shadow":"shadow-35XDy"};